// src/pages/NotFound.tsx
import React from 'react';
import { AlertCircle, Home, HelpCircle, ArrowLeft } from 'lucide-react';
import Button from '../components/Common/Button';
import { useNavigate, Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-color-primary/10 to-color-secondary/10 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Ícone 404 */}
        <div className="mb-8">
          <div className="text-8xl font-bold text-color-primary/50 mb-4">404</div>
          <AlertCircle className="mx-auto text-color-error mb-6" size={64} />
        </div>

        {/* Mensagem */}
        <h1 className="text-4xl font-bold text-color-text mb-3">Página não encontrada</h1>
        <p className="text-lg text-color-text-secondary mb-8">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </p>

        {/* Sugestões */}
        <div className="bg-color-info/10 border border-color-info/30 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-3 mb-4">
            <HelpCircle className="text-color-info flex-shrink-0 mt-1" size={20} />
            <div className="text-left">
              <h3 className="font-bold text-color-text mb-2">Você pode:</h3>
              <ul className="text-sm text-color-text-secondary space-y-1">
                <li>• Voltar para a página anterior</li>
                <li>• Ir para a página inicial</li>
                <li>• Entrar em contato com suporte</li>
                <li>• Verificar a URL</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Botões */}
        <div className="space-y-3">
          <Button
            variant="primary"
            fullWidth
            size="lg"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft size={18} />}
          >
            Voltar Atrás
          </Button>

          <Link to="/" className="block">
            <Button
              variant="outline"
              fullWidth
              size="lg"
              icon={<Home size={18} />}
            >
              Ir para Home
            </Button>
          </Link>
        </div>

        {/* Links Úteis */}
        <div className="mt-12 pt-8 border-t border-color-border">
          <p className="text-sm text-color-text-secondary mb-4">Links úteis:</p>
          <div className="flex flex-wrap gap-4 justify-center text-sm">
            <Link to="/" className="text-color-primary hover:underline">
              Home
            </Link>
            <Link to="/filiacao" className="text-color-primary hover:underline">
              Filiação
            </Link>
            <Link to="/cursos" className="text-color-primary hover:underline">
              Cursos
            </Link>
            <Link to="/fale-conosco" className="text-color-primary hover:underline">
              Contato
            </Link>
          </div>
        </div>

        {/* Código de Erro */}
        <div className="mt-8 text-xs text-color-text-secondary opacity-50">
          Erro 404 • {new Date().toLocaleTimeString('pt-BR')}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
